import { Bone, SkeletonFormCard } from '../primitives';

// Matches integration/Player.js's 2-column layout: settings cards on the left,
// a sticky PlayerPreview on the right.
export default function PlayerSkeleton() {
    return (
        <div className="row">
            <div className="col-xl-6" style={{ display: 'flex', flexDirection: 'column', gap: 16 }}>
                {[1, 2, 3].map((i) => (
                    <SkeletonFormCard key={i} fields={1} showButton={false} />
                ))}
            </div>
            <div className="col-xl-6">
                <div style={{ border: '1px solid #E2E8F0', borderRadius: 13, padding: 20 }}>
                    <Bone h={200} r={10} />
                </div>
            </div>
        </div>
    );
}
